import Header from './Header';
import BottomNav from './BottomNav';

const Layout = ({ children, currency, setCurrency }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header currency={currency} setCurrency={setCurrency} />
      
      {/* Body content */}
      <div className="pt-20 pb-16 px-6">
        {children}
      </div>
      
      {/* Bottom navigation for mobile */}
      <BottomNav />
    </div>
  );
};

export default Layout;